import { fromJS } from 'immutable'
import { compose } from 'ramda'
import { set, setIn } from 'utils/immutable'
import {
  SUCCESS_ODX_MODULES,
  SUCCESS_MODULES_VARIANTS,
  SUCCESS_VARIANT_DOMAINS,
  SUCCESS_FRAGMENT_DETAILS,
  SUCCESS_DOMAIN_PART_NUMBERS,
  SUCCESS_PART_DETAILS,
  SUCCESS_DOMAIN_FRAGMENTS,
  SET_VARIANT_BREADCRUMB,
  RESET_VARIANT_BREADCRUMB,
  SET_FRAGMENT_BREADCRUMB,
  RESET_FRAGMENT_BREADCRUMB,
  SET_PART_NUMBER_BREADCRUMB,
  RESET_PART_NUMBER_BREADCRUMB,
} from 'actions/dataTranslator'
import { createReducer } from './utils'

const initialState = fromJS({
  modules: [],
  variants: {},
  domains: {},
  fragments: {},
  fragmentDetails: {},
  partNumbers: {},
  domainPartDetails: {},
  showVariantBreadcrumb: false,
})

const handlers = {
  [SUCCESS_ODX_MODULES]: setModules,
  [SUCCESS_MODULES_VARIANTS]: setModuleVariants,
  [SUCCESS_VARIANT_DOMAINS]: setVariantDomains,
  [SUCCESS_FRAGMENT_DETAILS]: setFragmentDetails,
  [SUCCESS_DOMAIN_PART_NUMBERS]: setDomainPartNumbers,
  [SUCCESS_PART_DETAILS]: setDomainPartDetails,
  [SUCCESS_DOMAIN_FRAGMENTS]: setDomainFragments,
  [SET_VARIANT_BREADCRUMB]: setVariantBreadcrumb,
  [RESET_VARIANT_BREADCRUMB]: resetVariantBreadcrumb,
  [SET_FRAGMENT_BREADCRUMB]: setFragmentBreadcrumb,
  [RESET_FRAGMENT_BREADCRUMB]: resetFragmentBreadcrumb,
  [SET_PART_NUMBER_BREADCRUMB]: setPartNumberBreadcrumb,
  [RESET_PART_NUMBER_BREADCRUMB]: resetPartNumberBreadcrumb,
}

export default createReducer(initialState, handlers)

function setModules(state, action) {
  const { data } = action
  return state.set('modules', data)
}

function setModuleVariants(state, action) {
  const { module, data } = action
  return state.setIn(['variants', module], data)
}

function setVariantDomains(state, action) {
  const { variant, data } = action
  const { fragments, partNumbers } = Object.keys(data).reduce(
    (acc, curr) => {
      acc.fragments[curr] = data[curr].fragments
      acc.partNumbers[curr] = data[curr].partNumbers
      return acc
    },
    {
      fragments: {},
      partNumbers: {},
    }
  )
  const transform = compose(
    set('partNumbers', partNumbers),
    set('fragments', fragments),
    setIn(['domains', variant], Object.keys(data))
  )
  return transform(state)
}

function setFragmentDetails(state, action) {
  const { fragment, data } = action
  return state.setIn(['fragmentDetails', fragment], data)
}

function setDomainPartNumbers(state, action) {
  const { vcdQualifier, data } = action
  return state.setIn(['partNumbers', vcdQualifier], data)
}

function setDomainPartDetails(state, action) {
  const { key, data } = action
  return state.setIn(['domainPartDetails', key], data)
}

function setDomainFragments(state, action) {
  const { vcdQualifier, data } = action
  return state.setIn(['fragments', vcdQualifier], data)
}

function setVariantBreadcrumb(state) {
  return state.set('showVariantBreadcrumb', true)
}

function resetVariantBreadcrumb(state) {
  return state.set('showVariantBreadcrumb', false)
}

function setFragmentBreadcrumb(state, { vcdQualifier }) {
  const transform = compose(
    set('showFragmentBreadcrumb', true),
    set('vcdQualifier', vcdQualifier)
  )
  return transform(state)
}

function resetFragmentBreadcrumb(state) {
  const transform = compose(
    set('showFragmentBreadcrumb', false),
    set('vcdQualifier', '')
  )
  return transform(state)
}

function setPartNumberBreadcrumb(state, { vcdQualifier }) {
  const transform = compose(
    set('showPartNumberBreadcrumb', true),
    set('vcdQualifier', vcdQualifier)
  )
  return transform(state)
}

function resetPartNumberBreadcrumb(state) {
  const transform = compose(
    set('showPartNumberBreadcrumb', false),
    set('vcdQualifier', '')
  )
  return transform(state)
}
